import { notification } from 'antd'
import CommonApi from './Apiservices/CommonAPI'


export default create

export function create(payload) {
  const state = {
    res: false
  }
  const body = {

    instrument_name: payload.instrument_name,

  }
  CommonApi.SaveData('/api/v1/admin/instrument/create', body)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state

}

export async function Edit(instrumentname, id) {
  const state = {
    res: false
  }
  const body = { instrument_name: instrumentname }

  await CommonApi.SaveData(`/api/v1/admin/instrument/update/${id}`, body)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state.res

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state.res
}




